import React from 'react';
import { Mail } from 'lucide-react';

const LOGO_URL = "/livrum-logo-light.webp";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-brand">
          <div className="flex items-center gap-2 mb-2">
            <img 
              src={LOGO_URL} 
              alt="Livrum" 
              style={{ height: '32px', width: 'auto' }}
            />
          </div>
          <a href="mailto:contato@livrum.com.br" className="footer-email">
            <Mail className="w-4 h-4" />
            contato@livrum.com.br
          </a>
        </div>
        
        <div className="footer-copyright">
          <span className="font-semibold" style={{ color: 'white' }}>Livrum</span>
          <span> - Copyright © 2026. Todos os direitos reservados.</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
